import { render, staticRenderFns } from "./SnippetList.vue?vue&type=template&id=3807290a&"
import script from "./SnippetList.vue?vue&type=script&lang=ts&"
export * from "./SnippetList.vue?vue&type=script&lang=ts&"
import style0 from "./SnippetList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports